/**
 * Decode common HTML entities in transcript/filing text so it displays properly
 * (e.g. &#8212; → —, &#8221; → ", &amp; → &)
 */
export function decodeHtmlEntities(text: string): string {
  if (!text || typeof text !== 'string') return text;
  const map: Record<string, string> = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#x27;': "'",
    '&nbsp;': ' ',
    '&#47;': '/',
    '&#8212;': '—',
    '&#8211;': '–',
    '&#8220;': '"',
    '&#8221;': '"',
    '&#8216;': "'",
    '&#8217;': "'",
  };
  let out = text;
  for (const [entity, char] of Object.entries(map)) {
    out = out.split(entity).join(char);
  }
  // Numeric entities &#1234; and &#x1a2b;
  out = out.replace(/&#(\d+);/g, (_, n) => String.fromCodePoint(parseInt(n, 10)));
  out = out.replace(/&#x([0-9a-fA-F]+);/g, (_, n) => String.fromCodePoint(parseInt(n, 16)));
  return out;
}
